import { Typography } from 'antd';

import { LeadCard } from '@app/components/LeadCard';
import { selectRecordModal } from '@app/components/RecordModal/model/selectors';
import type { ContentPropsType } from '@app/components/RecordModal/types';
import { TaskListProvider } from '@app/providers';
import { useAppSelector } from '@app/store';

import '@app/components/RecordModal/components/ClientCard/styles/ClientCard.desktop.scss';

const PF = 'client-card-in-record-modal';
const { Title } = Typography;

export const ClientCard: ContentPropsType = () => {
  const { clientId, record } = useAppSelector(selectRecordModal);

  return (
    <TaskListProvider>
      <div className={PF}>
        <Title className={`${PF}__title`} level={4}>
          Сообщения
        </Title>
        <div className={`${PF}__content`}>
          <LeadCard
            leadId={record?.LeadId || 0}
            showLeadList={false}
            showGoToLeadAction
            knownClientId={record?.ClientId ?? clientId ?? null}
          />
        </div>
      </div>
    </TaskListProvider>
  );
};
